import { AccordionSummary as MuiAccordionSummary, AccordionSummaryProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary {...props} />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, .05)' : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '&:hover': {
    background:
      'linear-gradient(-45deg, #e7e6e6 0%, #fafafa 15%, #e0dfdf 15%, #fff 35%, #eeebeb 85%,#dad8d8 100%)',
  },
  minHeight: 'auto !important',
  '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded': {
    margin: `10px 5px`,
  },
}));
